import { useSession } from './use-session'
import { useTenant } from './use-tenant'

export function useSegmentCode() {
  const { data: session } = useSession()
  const tenant = useTenant()
  return session?.user?.member.segmentCode || tenant.roCacheSegmentCode
}
